import { render, staticRenderFns } from "./Server_back.vue?vue&type=template&id=3890cbe9&"
import script from "./Server_back.vue?vue&type=script&lang=js&"
export * from "./Server_back.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.4@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports